(function(){
'use strict';

angular.module('classy').constant('CHANNEL', {
  FB: 'Facebook',
  DTD: 'DoubletheDonation',
  CAPI: 'MetaCapi',
  FRAPI: 'MetaFrapi'
});
})();